import coin from "@/domain/icon/svg/coin";
import cart from "@/domain/icon/svg/cart";
import linkExternal from "@/domain/icon/svg/link-external";
import trash from "@/domain/icon/svg/trash";
import qrCode from "@/domain/icon/svg/qr-code";
import faceHappy from "@/domain/icon/svg/faceHappy";
import download from "@/domain/icon/svg/download";
import chevronLeft from "@/domain/icon/svg/chevron-left";
import menu from "@/domain/icon/svg/menu";
import plusCircle from "@/domain/icon/svg/plus-circle";
import plus from "@/domain/icon/svg/plus";
import globe from "@/domain/icon/svg/globe";
import faceId from "@/domain/icon/svg/faceId";
import copy from "@/domain/icon/svg/copy";
import cameraShutter from "@/domain/icon/svg/camera-shutter";
import dotsVertical from "@/domain/icon/svg/dotsVertical";
import eye from "@/domain/icon/svg/eye";
import eyeSlash from "@/domain/icon/svg/eyeSlash";
import reload from "@/domain/icon/svg/reload";
import alertTriangle from "@/domain/icon/svg/alert-triangle";
import infoCircle from "@/domain/icon/svg/info-circle";
import bank from "@/domain/icon/svg/bank";
import stripe from "@/domain/icon/svg/stripe";
import closeCircle from "@/domain/icon/svg/close-circle";
import edit from "@/domain/icon/svg/edit";
import notificationMessage from "@/domain/icon/svg/notification-message";
import send from "@/domain/icon/svg/send";
import arrowLeft from "@/domain/icon/svg/arrow-left";

export const _icons = {
    coin,
    cart,
    linkExternal,
    download,
    trash,
    qrCode,
    faceHappy,
    chevronLeft,
    menu,
    plusCircle,
    plus,
    globe,
    faceId,
    copy,
    cameraShutter,
    dotsVertical,
    eye,
    eyeSlash,
    reload,
    alertTriangle,
    infoCircle,
    bank,
    stripe,
    closeCircle,
    edit,
    notificationMessage,
    send,
    arrowLeft
}